import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SaleRefundInteracComponent } from './sale-refund-interac.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';
import { SalonMonsterLoadMaskModule } from '../../../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterSmallCheckMarkLoaderModule } from '../../../../components/smr-small-checkmark-loader/smr-small-checkmark-loader.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    SharedModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterSmallCheckMarkLoaderModule
  ],
  declarations: [SaleRefundInteracComponent],
  exports: [SaleRefundInteracComponent]
})
export class SaleRefundInteracComponentModule {}